// src/components/Graphics/DashboardTopSelling.jsx
import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer
} from "recharts";
import { getTopSellingProducts } from "../../services/dashboards";

export default function DashboardTopSelling({ inventarioId }) {
  const [data, setData] = useState([]);

  useEffect(() => {
    if (!inventarioId) return;
    const fetchData = async () => {
      try {
        const res = await getTopSellingProducts({ inventario: inventarioId });
        setData(res);
      } catch (err) {
        console.error("Error al cargar productos más vendidos:", err);
      }
    };
    fetchData();
  }, [inventarioId]);

  return (
    <div className="bg-white rounded-lg shadow p-6 mt-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-4">
        Productos más vendidos (últimos 45 días)
      </h2>
      {data.length > 0 ? (
        <ResponsiveContainer width="100%" height={500}>
          <BarChart
            data={data}
            margin={{ top: 20, right: 30, left: 10, bottom: 100 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="nombre" type="category" angle={-45} textAnchor="end" interval={0} height={120} />
            <YAxis type="number" />
            <Tooltip formatter={(value) => `$${value}`} />
            <Bar dataKey="total_vendido" fill="#4f46e5" />
          </BarChart>
        </ResponsiveContainer>
      ) : (
        <p className="text-gray-500 text-center">No hay productos vendidos en este periodo.</p>
      )}
    </div>
  );
}
